import { Grid } from "@material-ui/core";
import React from "react";

export const StatusBarReference = () => {
	return (
		<Grid
			container
			alignItems="center"
			spacing={2}
			style={{ padding: "10px 10px" }}
		>
			{/*Green */}
			<Grid item>
				<Grid container spacing={1} alignItems="center">
					<Grid item>
						<div
							style={{
								width: 15,
								height: 15,
								borderRadius: "50%",
								backgroundColor: "#4caf50",
								border: "1px solid rgba(0,0,0,0.2)",
							}}
						/>
					</Grid>
					<Grid item>
						<span>Used in 2 days</span>
					</Grid>
				</Grid>
			</Grid>

			{/* Yellow*/}
			<Grid item>
				<Grid container spacing={1} alignItems="center">
					<Grid item>
						<div
							style={{
								width: 15,
								height: 15,
								borderRadius: "50%",
								backgroundColor: "#ffd700",
								border: "1px solid rgba(0,0,0,0.2)",
							}}
						/>
					</Grid>
					<Grid item>
						<span>Used in 5 days</span>
					</Grid>
				</Grid>
			</Grid>

			{/* Grey */}
			<Grid item>
				<Grid container spacing={1} alignItems="center">
					<Grid item>
						<div
							style={{
								width: 15,
								height: 15,
								borderRadius: "50%",
								backgroundColor: "#a0a0a0",
								border: "1px solid rgba(0,0,0,0.2)",
							}}
						/>
					</Grid>
					<Grid item>
						<span>Not used in 5 days</span>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
